// extracted by css-extract-rspack-plugin
export default {"wrapper":"ChecksSection-module__wrapper__jba8P","content":"ChecksSection-module__content__vFj9n"};